import * as constants from 'constants/actions'

import initialState from './initialState'

const authenticationReducer = (state = initialState.user, action) => {
  switch (action.type) {
    case constants.API_LOGIN_REQUEST:
      return { ...state, session: null, errorMessage: '' }
    case constants.API_LOGIN_SUCCESS:
      return { ...state, session: action.session, ...action.user }
    case constants.API_LOGIN_ERROR:
      return { ...state, session: null, errorMessage: action.message }
    case constants.API_LOGOUT_SUCCESS:
      return { ...state, session: null }
    case constants.API_EDIT_USER_SUCCESS:
      return { ...state, ...action.user }
    case constants.API_GET_USER_SUCCESS:
      return { ...state, email: action.email }
    case constants.API_LOGOUT_ERROR:
      return { ...state, session: null, errorMessage: action.message }
    case constants.API_VERIFY_EMAIL_SUCCESS:
      return { ...state, sessionCode: action.data }
    default:
      return state
  }
}
export default authenticationReducer



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js